import React from "react";
import "../../Components/Menu/Menu.css";

export default function Terms() {
  return (
    <div>
      <h3 className="title">
        Brukervilkår og personvern for deg som bruker Bilista
      </h3>
      <h4 className="sub-title">Formål </h4>
      <p className="content">
        Bilista er utviklet og eid av Gjensidige Mobility Group AS (GMG), et
        selskap i Gjensidige-konsernet. Bilista kan lastes ned som en
        applikasjon til mobiltelefoner. Formålet med Bilista er å samle ulike
        tilbydere av bilrelaterte tjenester, slik at brukerne får en enklere,
        billigere og smartere bilhverdag.
      </p>
    </div>
  );
}
